import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { SampleReport } from '../../data/models';
import { SAMPLE_REPORTS } from '../../data/sample-reports.data';
import { SiteNavService } from '../../site-nav.service';

@Component({
  selector: 'ws-site-sample-report',
  templateUrl: './sample-report.component.html'
})
export class SiteSampleReportComponent implements OnDestroy {
  report: SampleReport;

  private readonly sub: Subscription;

  constructor(nav: SiteNavService) {
    this.sub = nav.page$.subscribe(page => {
      const r = SAMPLE_REPORTS.find(x => x.slug === page.slug);
      if (r) { this.report = r; }
    });
  }

  ngOnDestroy() { this.sub.unsubscribe(); }
}
